import { get } from "tiny-cookie";

export const getCsrfTokenFromUserCache = async () => {
  const userCache = await caches.open("user");
  const userCacheKeys = await userCache.keys();
  return userCacheKeys[0]?.headers.get("X-XSRF-TOKEN") ?? null;
};

export const getCsrfTokenFromCookie = () => get("XSRF-TOKEN");
